<template>
  <div class="student-detail-info-panel div-scroll">
    <div class="basic-info">
      <el-card class="card-left">
        <div class="photo">
          <el-image
            v-if="infoData.studentInfo.photoUrl"
            :src="infoData.studentInfo.photoUrl"
            :preview-src-list="[infoData.studentInfo.photoUrl]"
          >
          </el-image>
          <!-- <img
            :src="infoData.studentInfo.photoUrl"
            alt=""
            v-if="infoData.studentInfo.photoUrl"
          /> -->
          <img :src="photoSrc" alt="" v-else />
        </div>
        <ul class="info">
          <li>
            <span class="label">学号</span>
            <span class="value ellipsis">{{ infoData.studentNo }}</span>
          </li>
          <li>
            <span class="label">姓名</span>
            <span class="value ellipsis">{{ infoData.studentName }}</span>
          </li>
          <li>
            <span class="label">性别</span>
            <span class="value ellipsis">{{ infoData.sexName }}</span>
          </li>
          <li>
            <span class="label">出生日期</span>
            <span class="value ellipsis">{{ infoData.dateBirth }}</span>
          </li>
          <li>
            <span class="label">宿舍信息</span>
            <span class="value">{{ infoData.studentInfo.dormitoryInfo }}</span>
          </li>
        </ul>
      </el-card>
      <el-card class="card-right">
        <div class="right-title">
          <img src="../../assets/images/location/icon_jbxx.png" alt="" />
          <span>基本信息</span>
        </div>
        <ul class="right-info div-scroll">
          <li v-for="(item, index) in formItems" :key="index">
            <span class="label">{{ item.label }}</span>
            <span
              class="value ellipsis"
              :title="infoData.studentInfo[item.model] || ''"
              >{{ infoData.studentInfo[item.model] || "" }}</span
            >
          </li>
        </ul>
      </el-card>
    </div>
    <CCollapseItem :showSearch="false">
      <template slot="title-left"> 学习经历 </template>
      <template slot="body">
        <el-table
          highlight-current-row
          :header-row-style="{ color: '#3c3c3c' }"
          :row-style="{ color: '#6e6e6e' }"
          :data="infoData.experienceList"
          style="width: 100%"
        >
          <el-table-column
            prop="startTime"
            label="学习(工作)起始日期"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="endTime"
            label="学习(工作)终止日期"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="unit"
            label="学习(社会工作)部门"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="job"
            label="学习(社会工作)职务"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="verifyName"
            label="证明人姓名"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="verifyJob"
            label="证明人职务"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>

          <!-- <el-table-column
            prop="remark"
            label="备注"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column> -->
        </el-table>
      </template>
    </CCollapseItem>
    <CCollapseItem :showSearch="false">
      <template slot="title-left"> 奖励信息 </template>
      <template slot="body">
        <div style="padding: 0 10px 10px">{{ infoData.award || "无" }}</div>
      </template>
    </CCollapseItem>
    <CCollapseItem :showSearch="false">
      <template slot="title-left"> 处分信息 </template>
      <template slot="body">
        <div style="padding: 0 10px 10px">{{ infoData.punish || "无" }}</div>
      </template>
    </CCollapseItem>
    <CCollapseItem :showSearch="false">
      <template slot="title-left"> 家庭信息 </template>
      <template slot="body">
        <el-table
          highlight-current-row
          :header-row-style="{ color: '#3c3c3c' }"
          :row-style="{ color: '#6e6e6e' }"
          :data="infoData.familyList"
          style="width: 100%"
        >
          <el-table-column
            prop="relationship"
            label="与本人关系"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="姓名"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="dateBirth"
            label="出生日期"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="contactPhone"
            label="联系电话"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="politicalName"
            label="政治面貌"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="unit"
            label="工作单位"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="job"
            label="职务"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="income"
            label="每月经济收入"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </template>
    </CCollapseItem>
    <CCollapseItem :showSearch="false">
      <template slot="title-left"> 社会关系 </template>
      <template slot="body">
        <el-table
          highlight-current-row
          :header-row-style="{ color: '#3c3c3c' }"
          :row-style="{ color: '#6e6e6e' }"
          :data="infoData.relationList"
          style="width: 100%"
        >
          <el-table-column
            prop="name"
            label="姓名"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="relationship"
            label="关系"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="unit"
            label="单位"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="age"
            label="年龄"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="politicalName"
            label="政治面貌"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="contactPhone"
            label="联系电话"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="nationName"
            label="民族"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="job"
            label="职务"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- <el-table-column
            prop="remark"
            label="备注"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column> -->
        </el-table>
      </template>
    </CCollapseItem>
    <CCollapseItem :showSearch="false">
      <template slot="title-left"> 情况简介 </template>
      <template slot="body">
        <div style="padding: 0 10px 10px">{{ infoData.brief || "无" }}</div>
      </template>
    </CCollapseItem>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Configs from "./data/detail.js";
export default {
  props: {
    id: String,
    idCard: String,
    studentId: String,
    jxfFlag: {
      type: Boolean,
      default: false,
    },
    dormotoryFlag: {
      type: Boolean,
      default: false,
    },
    familyFlag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let { familyTableColumns, formItems, jxfFormItems, dormotoryItems } =
      Configs(this);
    return {
      tableColumns: familyTableColumns,
      formItems,
      jxfFormItems,
      dormotoryItems,
      infoData: {
        studentInfo: {},
        experienceList: [],
        awardPunish: "",
        familyList: [],
        relationList: [],
        brief: "",
      },
      familyInfo: [],
      jxfInfo: {},
      dormitoryInfo: {},
      photoSrc: "",
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE"]),
  },
  created() {},
  mounted() {
    this.getStudentInfo(this.id);
  },
  methods: {
    // 获取学生基本信息
    getStudentInfo(id) {
      this.$http
        .get("/account/base/student/getForm/" + id)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            let data = res.data;
            if (data) {
              let getters = this.$store.getters["dic/getDic"];
              if (data.studentInfo) {
                data.studentInfo.isDisabilityName = data.studentInfo
                  ? getters("_IS", data.studentInfo.isDisability)
                  : "";
                data.studentInfo.isOrphanName = data.studentInfo
                  ? getters("_IS", data.studentInfo.isOrphan)
                  : "";
                data.studentInfo.isStayName = data.studentInfo
                  ? getters("_IS", data.studentInfo.isStay)
                  : "";
              }
              if (!data.studentInfo.photoUrl) {
                if (data.studentInfo.sex == "female") {
                  this.photoSrc = require("../../assets/images/photo_girl.png");
                } else {
                  this.photoSrc = require("../../assets/images/photo_boy.png");
                }
              }
              this.infoData = data;
            }
          } else {
            this.$message.error("获取信息失败，" + res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("获取信息失败，" + err);
        });
    },
  },
};
</script>

